import { createUseStyles } from '@pe-libs/react-components/build/theme';

const useStyles = createUseStyles(
  'default-landing-header',
  ({
    breakpoints: {
      up,
      values: { lg },
    },
    palette: { common },
  }) => ({
    headerContainer: {
      background: common.white,
    },
    header: {
      maxWidth: `${lg}px`,
      width: '100%',
      margin: '0 auto',
      padding: '0.25rem 0.5rem',
      textShadow: 'none',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',

      [up('md')]: {
        padding: '0.25rem 3rem',
      },
    },
    logo: {
      height: '3.5rem',
    },
    logoLink: {
      width: '11.6875rem',
      display: 'flex',
    },
    registerLink: {
      marginRight: '16px',
    },
    rightSection: {
      display: 'flex',
      alignItems: 'center',
    },
  }),
);

export default useStyles;
